import _ from 'lodash'

export default {
  plural (object, value, args) {
    if (args === undefined) args = {}
    if (object === undefined) return value

    if (typeof object === 'number' && object === 0 || object.length === 0) {
      if (args.zero) {
        return this.$t(args.zero)
      }
      return this.$t('application.messages.not_found')
    }

    if (typeof object === 'number' && object === 1 || object.length === 1) {
      return this.$t(value + '.singular', _.merge({ count: object }, args))
    }

    if (typeof object === 'number' && object > 1 || object.length > 1) {
      return this.$t(value + '.plural', _.merge({ count: object }, args))
    }

    return value
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang.js